<template>
  <div class="relative cursor-auto"
       @click="show = true"
       v-click-outside="hide"
  >
    <slot></slot>

    <transition
      enter-class="mt-2 opacity-0"
      leave-class="mt-0 opacity-100"
      enter-to-class="mt-0 opacity-100"
      leave-to-class="mt-2 opacity-0"
    >
      <div v-if="show" class="duration-150 border border-gray-200 bg-white w-[45em] shadow-lg absolute left-full top-full z-10 rounded-lg" @click="clickOnConfig">
        <div v-if="loading || blocks.length">
          <div>
            <h3 class="p-4 pb-0 font-semibold text-lg text-gray-900 capitalize">{{ `"${displayRole}" blocks` }}</h3>
            <div class="p-4 flex items-center space-x-2">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              <input v-model="search"
                class="border-0 rounded-lg basis-full outline-none focus:ring-2 focus:ring-primary"
                placeholder="Search..."
              >
            </div>
          </div>
          <div v-if="!hasOnlyOneGeneralTab" class="border-b border-gray-200 pl-4">
            <nav class="-mb-px flex space-x-6 overflow-auto" aria-label="Tabs">
              <!-- Current: "border-indigo-500 text-indigo-600", Default: "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300" -->
              <span v-for="tab in tabs" :key="tab"
                    class="whitespace-nowrap border-transparent text-gray-500 cursor-pointer hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
                    :class="((tab === 'General' && !selectedTab) || (selectedTab === tab)) && '!border-blue-500 !text-blue-600'"

                    @click="selectTab(tab)"
              >
                <span>{{ tab }}</span>
              </span>
            </nav>
          </div>
          <ul class="my-4 px-4 grid grid-cols-2 gap-6 max-h-[25em] overflow-auto">
            <BlockPreview v-for="block in selectedBlocks" :key="block.id"
                          v-bind="block"
                          :block="block"
            />
          </ul>
        </div>
        <div v-else>
          <div class="text-center my-8 max-w-md mx-auto">
            <svg xmlns="http://www.w3.org/2000/svg" class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M14 10l-2 1m0 0l-2-1m2 1v2.5M20 7l-2 1m2-1l-2-1m2 1v2.5M14 4l-2-1-2 1M4 7l2-1M4 7l2 1M4 7v2.5M12 21l-2-1m2 1l2-1m-2 1v-2.5M6 18l-2-1v-2.5M18 18l2-1v-2.5" />
            </svg>
            <h3 class="mt-2 text-sm font-medium text-gray-900">No blocks found</h3>
            <p class="mt-1 text-sm text-gray-500">Try changing your filters. Contact your admin, you might not have the necessary permissions.</p>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

import { mapGetters } from "vuex"

import BlockPreview from "./BlockPreview"

export default {
  props: ['role', 'packageFilter'],
  components: {
    BlockPreview,
  },
  data() {
    return {
      show: false,
      loading: true,
      search: "",
      selectedTab: null,
      justClickedOnConfig: false,

      blocks: [],
    }
  },
  created() {
    this.loadBlocks()
  },
  methods: {
    clickOnConfig() {
      if (this.clickTimeout) {
        clearTimeout(this.clickTimeout)
      }

      this.justClickedOnConfig = true
      this.clickTimeout = setTimeout(() => this.justClickedOnConfig = false, 50)
    },
    async loadBlocks() {
      this.loading = true
      this.blocks = (await this.$store.dispatch("cachedGet", {
        endpoint: this.link + "/rest/V1/editor/list-available-blocks",
        headers: { Cookie: 'environment=editor' },
        params: {
          params: {
            role: this.role,
            packages: this.availablePackages
              .map(item => item.module_id)
              .filter(item => !this.packageFilter || this.packageFilter === item),
          },
        },
      })).data
      this.loading = false

      if (this.tabs[0] !== "General") {
        this.selectedTab = this.tabs[0]
      }
    },
    hide() {
      this.show = false
    },
    selectTab(tab) {
      if (tab === "General") return this.selectedTab = null
      this.selectedTab = tab
    },
  },
  computed: {
    ...mapGetters({
      link: 'editor/fullDomainLink',
      availablePackages: 'editor/availablePackages',
      iframeClickTrigger: 'editor/iframeClickTrigger',
    }),

    hasOnlyOneGeneralTab() {
      return this.tabs.length === 1 && this.tabs[0] === 'General'
    },
    tabs() {
      const obj = {}
      let hasUncategorized
      this.filteredBlocks.forEach(block => {
        if (block.category) obj[block.category] = true
        else hasUncategorized = true
      })

      const tabs = Object.keys(obj)
      if (hasUncategorized) tabs.unshift("General")
      return tabs
    },
    filteredBlocks() {
      const search = this.search
      if (!search) return this.blocks
      return this.blocks.filter(block => block.title.toLowerCase().includes(search.toLowerCase()))
    },
    selectedBlocks() {
      const selected = this.selectedTab
      if (!selected) {
        return this.filteredBlocks.filter(block => !block.category)
      }
      return this.filteredBlocks.filter(block => block.category === selected)
    },

    displayRole() {
      return this.role.replace(/-/g, " ")
    },
  },
  watch: {
    iframeClickTrigger() {
      !this.justClickedOnConfig && this.hide()
    },
    packageFilter() {
      this.loadBlocks()
    },
  },
}

</script>
